<template>
  <select :name="name" class="form-control" @change="onChange(name, selectedValue)" v-model="selectedValue">
    <option value="#">{{ firstEntryName }}</option>
    <option v-for="(option, index) in options" :key="index" :value="option[valueField]">
      {{ option[nameField] }}
    </option>
  </select>
</template>

<script>
export default {
  props: { 
    name: { String, required: true },
    options: { Array, required: true },
    valueField: { String, required: true },
    nameField: { String, required: true },
    firstEntryName: { String, required: false, default: 'All' },
    selected: { Number, required: false, default: '#' },
  },
  data() {
    return {
      selectedValue: this.selected ? this.selected : '#'
    }
  },
  mounted() {
    this.sendDropdownFilterEvent(this.name, this.selectedValue);
  },
  created() {
    // reset dropdown to initial state when all filtes are reset
    EventDispatcher.listen('resetFilters', () => {
      this.selectedValue = '#';
    });
  },
  methods: {
    onChange(name, selectedValue) {
      this.sendDropdownFilterEvent(name, selectedValue);
    },
    sendDropdownFilterEvent(name, selectedValue) {
      EventDispatcher.fire('dropdownFiltersApplied', { 
        'name': name, 
        'value': selectedValue 
      });
    }
  }
}
</script>

<style lang="scss" scoped>
  select {
    font-size: 0.9rem;
    height: 35px;
    background-color: lighten($color: #96abae, $amount: 10);
    border: 1px solid rgba(0, 0, 0, 0.125);
    &:focus {
      background-color: lighten($color: #96abae, $amount: 20);
      border-color: lighten($color: #96abae, $amount: 10);
      box-shadow: 0 0 0 0.1rem darken($color: #96abae, $amount: 10);
    }
  }
</style>

